<template>
  <in-out-stock stock-type="out" />
</template>

<script>
import InOutStock from '@/views/wms/stock/InOutStock.vue'

export default {
  name: 'outstock',
  components: {
    InOutStock,
  },
}
</script>
